interface PaintDripProps {
  className?: string;
  style?: React.CSSProperties;
}

export function PaintDrip({ className = '', style }: PaintDripProps) {
  return (
    <div
      className={className}
      style={{
        position: 'absolute',
        left: 0,
        width: '100%',
        height: '140px',
        zIndex: 1,
        pointerEvents: 'none',
        lineHeight: 0,
        ...style,
      }}
    >
      <svg
        viewBox="0 0 1440 320"
        preserveAspectRatio="none"
        style={{
          position: 'absolute',
          left: 0,
          width: '100%',
          height: '100%',
          display: 'block',
        }}
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="paintDripGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#0f172a" stopOpacity="0.38" />
            <stop offset="50%" stopColor="#0f172a" stopOpacity="0.12" />
            <stop offset="100%" stopColor="#0f172a" stopOpacity="0" />
          </linearGradient>
        </defs>
        <path
          d="M0,128L48,144C96,160,192,192,288,186.7C384,181,480,139,576,122.7C672,107,768,117,864,138.7C960,160,1056,192,1152,197.3C1248,203,1344,181,1392,170.7L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          fill="url(#paintDripGrad)"
        />
      </svg>
    </div>
  );
}
